<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            ajax-path="sms"
        />        
        <app-modal 
            :show.sync="showSendModal" 
            @close="sendModalClosed"
            width="md:w-1/2 lg:w-1/3"
        >
            <template slot="header">Send SMS</template>
            <template slot="body">
                <app-input
                    v-model="sendForm.phone_number"
                    placeholder="Phone Number"
                    :error="sendForm.errors.get('phone_number')"
                    @updated="sendForm.errors.clear('phone_number')"
                    focus
                    integer
                />
                <app-textarea 
                    v-model="sendForm.message"
                    placeholder="Message"
                    :error="sendForm.errors.get('message')"
                    @updated="sendForm.errors.clear('message')"
                />
                <div class="text-right mt-5">
                    <app-button 
                        class="btn-blue"
                        :loading="sendFormIsLoading"
                        @click="store"
                    >Send</app-button>
                </div>
            </template>
        </app-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Form from '@/helpers/Form';
    import debounce from 'lodash/debounce';
    
    export default {
        data() {
            return {
                sendForm: new Form({
                    phone_number: null,
                    message: null,
                }),
                sendFormIsLoading: false,
                showSendModal: false,
                refreshTable: false,
                columns: [
                    {
                        title: 'Phone Number',
                        field: 'phone_number',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Message', 
                        field: 'message', 
                        sorter: 'string',
                        minWidth: 200,
                    },
                ],
                actions: [
                    {
                        label: 'Resend',
                        icon: () => import('@/icons/Update.vue'),
                        handler: sms => {
                            this.resend(sms[0])
                        },
                        requiredSelect: true,
                    },
                    {
                        label: 'Delete',
                        icon: () => import('@/icons/DeleteOutlined.vue'),
                        handler: sms => {
                            this.delete(sms[0]);
                        },
                        requiredSelect: true,
                    },
                    {
                        label: 'Send',
                        icon: () => import('@/icons/Send.vue'),
                        handler: this.add,
                    }
                ]
            }
        },
        computed: {
            ...mapGetters({
                items: 'sms/items',          
            }),
        },
        methods: {                      
            resend(sms) {
                this.$swal.fire({
                    type: 'warning',
                    title: 'Are you sure?',
                    html: `You are about to resend "<strong>${sms.message}</strong>" SMS to <strong>${sms.phone_number}</strong>.`,
                    showCancelButton: true,
                    confirmButtonColor: '#f56565',
                    confirmButtonText: 'Yes, resend it!',
                    showLoaderOnConfirm: true,
                    preConfirm: (response) => {
                        return this.$store.dispatch('sms/resend', sms.id);
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if (result.value) {
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'SMS was successfully resent.'
                        })
                    }
                })
            },
            sendModalClosed() {
                this.sendForm.reset();
                this.sendForm.errors.clear();
            },
            add() {
                this.showSendModal = true;
            },
            store() {
                this.sendFormIsLoading = true;
                this.sendForm.errors.clear();
                this.$store.dispatch('sms/store', this.sendForm.payload())
                    .then(() => {
                        this.sendFormIsLoading = false;
                        this.showSendModal = false;
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'SMS was added successfully.'
                        })
                    })
                    .catch(({ response }) => {
                        this.sendFormIsLoading = false;
                        this.sendForm.errors.record(response.data);
                    })
            },            
            delete(sms) {
                this.$swal.fire({
                    type: 'warning',
                    title: 'Are you sure?',
                    html: `You are about to delete "<strong>${sms.message}</strong>" SMS permanently.`,
                    showCancelButton: true,
                    confirmButtonColor: '#f56565',
                    confirmButtonText: 'Yes, delete it!',
                    showLoaderOnConfirm: true,
                    preConfirm: (response) => {
                        return this.$store.dispatch('sms/delete', sms.id);
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if (result.value) {
                        this.refreshTable = true;
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'SMS was successfully deleted.'
                        })
                    }
                })                
            },                  
        }
    }
</script>